export default __webpack_public_path__ + "static/media/uk-600.b2c40183.webp";